import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorHeader: {
		id: 'servicedesk-external-links.error-header',
		defaultMessage: 'We couldn’t load your links',
		description: 'Title for the external links error page',
	},
	errorDescription: {
		id: 'servicedesk-external-links.error-description',
		defaultMessage: 'Refresh the page to try again.',
		description: 'Description for the external links error page',
	},
});
